import { FC } from 'react';

const CustomAnimations: FC = () => {
  return (
    <style jsx global>{`
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes subtlePulse {
        0% {
          opacity: 0.5;
        }
        50% {
          opacity: 0.7;
        }
        100% {
          opacity: 0.5;
        }
      }

      @keyframes gradientAnimation {
        0% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
        100% {
          background-position: 0% 50%;
        }
      }

      .animate-fadeIn {
        animation: fadeIn 0.5s ease-in-out forwards;
      }
      .animate-fadeInUp {
        animation: fadeInUp 0.7s ease-out forwards;
      }
      .animate-subtlePulse {
        animation: subtlePulse 4s ease-in-out infinite;
      }
      .animate-gradient {
        animation: gradientAnimation 15s ease infinite;
        background-size: 300% 300%;
      }

      .transition-smooth {
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
      }

      .bg-paper-grid {
        background-size: 40px 40px;
        background-image: linear-gradient(
            to right,
            var(--primary) / 7% 1px,
            transparent 1px
          ),
          linear-gradient(to bottom, var(--primary) / 7% 1px, transparent 1px);
      }
    `}</style>
  );
};

export default CustomAnimations;
